var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":("confirm-block-modal-" + _vm.deviceId),"title":"Block Device","size":"lg"},on:{"ok":_vm.blockDevice}},[_c('p',[_vm._v("Are you sure you want to block this device?")])])}
var staticRenderFns = []

export { render, staticRenderFns }